/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useNavigate, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import { Arr, Language, Menu, Notification } from "../svg/AllSvg";
import Logo from "../../../assets/images/logo.svg"
import Logo1 from "../../../assets/images/logo1.svg"
import Logo2 from "../../../assets/images/logo2.svg"
import { useEffect, useRef, useState } from "react";
import { dataActions } from "../../../shared/store/data-Slice";
import { useDispatch, useSelector } from "react-redux";
import { languages } from "../../../shared/utils/languages";
import { uiActions } from "../../../shared/store/ui-Slice";
import { useTranslation } from "react-i18next";
import useSelectPrimary from "../../../shared/hooks/use-selectPrimary";
import ProfilePopup from "./ProfilePopup";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import SideBar from "./SideBar";

const DropdownIndicator = (props: any) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <Arr className="min-w-[9px] fill-[#a5a5a5]" />
            </components.DropdownIndicator>
        )
    );
};

const ChatbotHeader = () => {
    const isLogin: boolean = useSelector((state: any) => state.auth.isLogin);
    const theme: any = useSelector((state: any) => state.ui.theme);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const user: any = useSelector((state: any) => state.auth.user);
    const profile: boolean = useSelector((state: any) => state.data.profile);
    const [langFocus, setLangFocus] = useState<boolean>(false);
    const [langValue, setLangValue] = useState<any>(null);
    const [select, setSelect] = useState<any>(null);
    const [menu, setMenu] = useState<any>(null);
    const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const { i18n, t } = useTranslation('common');
    const params = useParams();
    const ref1: any = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let styles = useSelectPrimary(theme, false);

    const getMenu = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.menu}chatbot-main-menu/`);

            if (res && res?.status === 200) {
                setData(res?.data)
            }
        } catch (error) {
            console.error("error while feching header menu", error);
        }
    };

    useEffect(() => {
        if (data?.length > 0) {
            let route: any;
            let obj: any = { mainmenu: "", submenu: "" }
            if (!!params?.lang) {
                if (window.location.pathname === `/${lang}`) {
                    route = window.location.pathname?.replace(`/${lang}`, "/");
                } else {
                    route = window.location.pathname?.replace(`/${lang}/`, "/");
                }
            } else {
                route = window.location.pathname;
            }
            for (let i = 0; i < data?.length; i++) {
                const el = data[i];
                let mainUrl: any = el?.url;
                if (route?.includes(mainUrl)) {
                    obj.mainmenu = el?.title
                    if (route !== "/" && (obj.mainmenu === "Home" || obj.mainmenu === "होम")) {
                        obj.mainmenu = ''
                    }
                }

                for (let j = 0; j < el?.subRoutes?.length; j++) {
                    const s = el?.subRoutes[j];
                    let subUrl: any = s?.url;
                    if (route?.includes(subUrl)) {
                        obj.mainmenu = el?.title
                        obj.submenu = s?.title
                    }
                }
            }

            setMenu(obj)
        }
    }, [data, window.location.pathname])

    useEffect(() => {
        (!!lang && isLogin) && getMenu();
    }, [lang, isLogin])

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref1.current && !ref1.current.contains(event.target)) {
                dispatch(dataActions.setProfile(false));
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref1]);

    useEffect(() => {
        if (!!params?.lang) {
            if (params?.lang === "hi" || params?.lang === "en" || params?.lang === "mr") {
                let obj: any = languages?.find((item: any) => item?.value === params?.lang);

                if (!!obj && Object?.keys(obj)?.length > 0) {
                    setLangValue(obj)
                    i18n.changeLanguage(obj?.value);
                    dispatch(uiActions.changeLang(obj?.value));
                } else {
                    setLangValue({ label: "English", value: "en", text: "English" })
                    i18n.changeLanguage("en");
                    dispatch(uiActions.changeLang("en"));
                }
            } else {
                navigate("/en")
            }
        } else {
            setLangValue({ label: "English", value: "en", text: "English" })
            i18n.changeLanguage("en");
            dispatch(uiActions.changeLang("en"));
        }
    }, [params?.lang])

    const handleChange = (e: any) => {
        if (lang !== e?.value) {
            dispatch(dataActions.setSelectLang(e));
            dispatch(dataActions.setLangOpen(true));
        }
    }

    const handleOpen = (e: any, index: any, length: any) => {
        if (e?.key === "Tab") {
            setSelect(index)
        }
    }

    return (
        <>
            {/* Backdrop */}
            <span
                className={`fixed top-0 left-0 z-20 ${sidebarOpen ? "block xl:hidden" : "hidden"
                    } h-screen w-full bg-[#00000080]`}
                onClick={() => setSidebarOpen(!sidebarOpen)}
            ></span>

            <div className="w-full pt-[18px] md:pt-[22px] xlx:pt-[40px] container md:px-[15px] px-0">
                <div className="md:h-[65px] mms:h-[75px] xlx:h-[100px] rounded-[10px] border border-[rgba(76,143,186,0.20)] flex items-center justify-between w-full bg-white md:flex-row flex-col md:pl-[5px] md:pr-[20px] xlx:pl-[15px] xlx:pr-[30px] px-0 md:gap-[15px]">
                    <Link to={`${!!params?.lang ? `/${params?.lang}` : "/"}`} className="md:order-1 order-2 flex items-center justify-start md:w-fit w-full py-[4px] px-[10px] md:p-0 hover:bg-[#f4f4f4] hover:rounded-[10px] focus:bg-[#f4f4f4] focus:rounded-[10px]">
                        <img src={lang === "en" ? Logo : lang === "hi" ? Logo1 : Logo2} alt={`${lang === "en" ? "Mumbai Metro Rail Corporation Limited" : lang === "hi" ? "मुंबई मेट्रो रेल कॉर्पोरेशन लिमिटेड" : "मुंबई मेट्रो रेल कॉर्पोरेशन मर्यादित"}`} className='w-[280px] md:w-[300px] mms:w-[338px] lgl:w-[360px] xlx:w-auto' />
                    </Link>

                    <div className="flex items-center md:order-2 order-1 md:w-auto w-full justify-end py-[2px] border-b md:border-0 border-[#D8D8D8] px-[10px] md:p-0">
                        {isLogin && <>
                            <nav className="h-full items-center gap-[15px] pr-[10px] lg:pr-[15px] xl:flex hidden">
                                <ul className="items-center h-full gap-[20px] xl:gap-[25px] flex">
                                    {Array.isArray(data) && data?.map((item: any, index: number) => (
                                        <li key={index} className="group h-full relative">
                                            {(menu?.mainmenu === item?.title) && <div className="absolute top-[-8px] left-0 right-0 flex items-center justify-center w-full">
                                                <div className="h-[3px] duration-300 flex items-center justify-center w-[19px] bg-primaryText rounded-full"></div>
                                            </div>}
                                            <Link to={!!params?.lang ? `/${params?.lang + item?.url}` : item?.url} className={`flex items-center *:font-medium font-medium gap-[6px] h-full ${(menu?.mainmenu === item?.title) ? "text-primaryText" : `${select === index ? "text-primary" : "text-blackDull"} group-hover:text-primary`}`} onClick={(e: any) => item?.subRoutes?.length > 0 && e.preventDefault()} onKeyDown={(e: any) => handleOpen(e, index, item?.subRoutes?.length)} onFocus={() => setSelect(index)} onBlur={() => setSelect(null)}>
                                                <h5>{item?.title}</h5>
                                                {item?.subRoutes?.length > 0 && <Arr className={`${(menu?.mainmenu === item?.title) ? "fill-primaryText" : `${select === index ? "fill-primary" : "fill-blackDark"} group-hover:fill-primary`} min-w-[9px]`} />}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </nav>

                            <div className="h-[13px] xlx:h-[15px] border-r border-[#D8D8D8] xl:block hidden mx-[1px]"></div>
                        </>}

                        {/* language change */}
                        <div aria-label={t("aria_label.lang")} title={t("aria_label.lang")} className={`flex items-center h-full xsm:px-[7px] lg:px-[15px] md:py-[1px] ${langFocus && "shadow-[0_0_0_1px_#5b44955e] rounded-[4px]"} hover:shadow-[0_0_0_1px_#5b44955e] hover:rounded-[4px]`}>
                            <div className="mm:w-auto mm:h-auto xlsm:w-[16px] xlsm:h-[16px] w-[14px] h-[14px]">
                                <Language />
                            </div>

                            <Select options={languages} styles={styles} className="!w-full language-select" classNamePrefix="language-select" onChange={(e: any) => handleChange(e)} value={langValue} isSearchable={false} onFocus={() => setLangFocus(true)} onBlur={() => setLangFocus(false)} aria-label={t("aria_label.lang")} components={{ DropdownIndicator }} />
                        </div>

                        <div className="h-[13px] xlx:h-[15px] border-r border-[#D8D8D8] mx-[1px]"></div>

                        <div className="flex items-center h-full xsm:px-[7px] lg:px-[12px]">
                            <button className="flex items-center justify-center focus:shadow-[0_0_0_1px_#5b44955e] hover:shadow-[0_0_0_1px_#5b44955e] hover:rounded-[4px] focus:rounded-[4px] p-[3px]">
                                <Notification />
                            </button>
                        </div>

                        <div className="h-[13px] xlx:h-[15px] border-r border-[#D8D8D8]"></div>

                        <div className="relative xl:pr-0 px-[4px] xsm:px-[7px]" ref={ref1}>
                            <button onClick={() => !!user ? dispatch(dataActions.setProfile(true)) : dispatch(dataActions.setLoginOpen(true))} className="focus:shadow-[0_0_0_1px_#D8D8D8] hover:shadow-[0px_0px_0px_1px_#D8D8D8] hover:rounded-[4px] focus:rounded-[4px] px-[6px]">
                                {!!user ? <h5 className="flex items-center gap-[4px] lg:gap-[8px] text-blackDark font-semibold text-sm sm:text-base"><span className="truncate w-[80px] sm:w-full">{user?.first_name + " " + user?.last_name}</span>  <Arr className="min-w-[9px] fill-[#1C1B1F]" /></h5> : <h5 className="text-blackDark font-semibold text-sm sm:text-base">{t("header.login_signup")}</h5>}
                            </button>
                            {profile && <ProfilePopup type="chatbot" />}
                        </div>

                        {isLogin && <>
                            <div className="h-[13px] xlx:h-[15px] border-r border-[#D8D8D8] xl:hidden"></div>

                            <button aria-label={t("aria_label.menu")} title={t("aria_label.menu")} className="xl:hidden ml-[6px] min-w-[28px] h-[28px] flex items-center justify-center focus:shadow-[0_0_0_1px_#059db25e] hover:shadow-[0_0_0_1px_#059db25e] hover:rounded-[4px] focus:rounded-[4px]" onClick={() => setSidebarOpen(true)}>
                                <Menu />
                            </button>
                        </>}
                    </div>
                </div>
            </div>

            {/* Mobile Sidebar */}
            <SideBar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} menu={data} selectedMenu={menu} type="chatbot" select={select} setSelect={setSelect} handleOpen={handleOpen} login={true} />
        </>
    );
};

export default ChatbotHeader;